import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

// Langkah enroll aplikasi authenticator: scan QR atau ketik secret secara manual.
const AuthenticatorSetup = ({ sharedKey, authenticatorUri }) => {
  const [copied, setCopied] = useState(false);

  const copyKey = async () => {
    try {
      await navigator.clipboard.writeText(sharedKey.replace(/\s/g, ''));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className='mfa-setup mb-3'>
      <ol className='mfa-setup__steps mb-3'>
        <li>
          Install an authenticator app on your phone, such as Google
          Authenticator or Microsoft Authenticator.
        </li>
        <li>Scan the QR code below with the app.</li>
        <li>Enter the 6-digit code shown in the app.</li>
      </ol>

      <div className='mfa-setup__qr d-flex flex-column flex-sm-row align-items-center gap-3'>
        <div className='mfa-setup__qr-box'>
          <QRCodeSVG
            value={authenticatorUri}
            size={156}
            level='M'
            title='Authenticator QR code'
          />
        </div>
        <div className='flex-grow-1 w-100'>
          <p className='mfa-setup__hint mb-1'>
            Can&apos;t scan the code? Enter this key manually:
          </p>
          <div className='d-flex align-items-center gap-2'>
            <code className='mfa-setup__key' aria-label='Authenticator key'>
              {sharedKey}
            </code>
            <button
              type='button'
              className='btn btn-sm btn-light'
              onClick={copyKey}
              aria-label='Copy authenticator key'
            >
              <i
                className={copied ? 'ri-check-line' : 'ri-file-copy-line'}
                aria-hidden='true'
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticatorSetup;
